let generateSrcset = (img, widths = []) => {
  let url = new URL(img.src);
  return widths
    .filter((w) => w <= img.width)
    .map((w) => {
      url.searchParams.set('width', w.toString());
      return `${url.href} ${w}w`;
    })
    .join(', ');
};

let createImageElement = (variant, className, sizes, altText) => {
  let imgData = variant.preview_image;
  let img = new Image(imgData.width, imgData.height);
  img.className = className;
  img.alt = variant.alt || altText;
  img.sizes = sizes;
  img.src = imgData.src;
  img.srcset = generateSrcset(imgData, [165, 360, 533, 720, 940, 1066]);
  img.loading = 'lazy';
  return img;
};

let checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
      input.addEventListener('click', (e) => {
        let firstMedia = wrapper.querySelector('.media--first');
        let secondMedia = wrapper.querySelector('.media--second');
        let productHandle = wrapper.dataset.product;
        if (e.currentTarget.checked && firstMedia) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', e.currentTarget.dataset.variantLink);
          let addBtn = wrapper.querySelector('.card__add-to-cart button[name="add"]');
          if (addBtn) {
            addBtn.setAttribute('aria-disabled', 'false');
            let span = addBtn.querySelector('span');
            let soldOut = addBtn.querySelector('.sold-out-message');
            span?.classList.remove('hidden');
            soldOut?.classList.add('hidden');
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = e.currentTarget.dataset.variantId;
          }
          let selectedColor = e.currentTarget.value;
          let productUrl = `${window.Shopify.routes.root}products/${productHandle}.js`;
          fetch(productUrl)
            .then((res) => {
              if (!res.ok) throw new Error('Network response was not ok');
              return res.json();
            })
            .then((productData) => {
              let variant = productData.variants.find((v) => v.featured_media && v.options.includes(selectedColor));
              if (variant) {
                let newImg = createImageElement(
                  variant.featured_media,
                  firstMedia.className,
                  firstMedia.sizes,
                  productData.title
                );
                if (newImg.src !== firstMedia.src) {
                  let swapped = false;
                  if (secondMedia && new URL(secondMedia.src).pathname === new URL(newImg.src).pathname) {
                    firstMedia.remove();
                    secondMedia.classList.remove('media--second');
                    secondMedia.classList.add('media--first');
                    swapped = true;
                  }
                  if (!swapped) {
                    firstMedia.animate([{ opacity: 1 }, { opacity: 0 }], {
                      duration: 200,
                      easing: 'ease-in',
                      fill: 'forwards',
                    });
                    setTimeout(() => {
                      firstMedia.parentNode.replaceChild(newImg, firstMedia);
                      newImg.animate([{ opacity: 0 }, { opacity: 1 }], {
                        duration: 200,
                        easing: 'ease-in',
                        fill: 'forwards',
                      });
                      secondMedia?.remove();
                    }, 200);
                  }
                }
              }
            })
            .catch((err) => console.error('There was a problem with the fetch operation:', err));
        }
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();
  document.addEventListener('shopify:section:load', checkSwatches);
}

colorSwatches();
